<template>
  <section class="mt-4 prose prose-sm  text-gray-700">
    <p>
      Thank you in advance, for your custom, it is greatly appreciated. We are a 
      small independent shop so every order counts!
    </p>
    <p>
      Your order will be dispatched via Royal Mail. Of course, we aim to process
      all orders as quickly as possible. We will always let you know as soon as 
      possible if there is a delay.
    </p>
    <p>
      All packaging and gift wrapping used is plastic free and 100% recyclable.
    </p>
    <p>
      We are always looking for ways to improve our packaging and reduce our impact 
      on the environment. If you have any suggestions, please do let us know.
    </p>
    <p>
      For UK mainland deliveries, we aim to <strong>dispatch</strong> all orders 
      within 1-2 working days. We will always let you know if there is a delay with 
      the conytact details you have provided.
    </p>
    <p>
      Free UK delivery on orders over £60 - *T&Cs apply.
    </p>
    <ul>
      <li>
        UK Standard Delivery: £3.95 - Up To 5 Working Days
      </li>
      <li>
        UK Express Delivery: ﻿£7.50 - 1-2 Working Days.
      </li>
    </ul>
    <p class="italic">
      * Weight & location delivery costs will vary on larger products.
    </p>
    <p>
      * Express Delivery is only available for orders placed on Monday - Thursday. 
      All express orders must be placed by 3pm.
    </p>
  </section>
</template>